import { Spacer, VDBText } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import HyperLinkModal from "@components/molecules/HyperLinkModal";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { VDBIcons } from "@utils/VDBIcons";
import { useState } from "react";
import styled from "styled-components/native";
import { DefaultTheme } from "styled-components/native";
import { css } from "styled-components/native";

interface LabelOnlySectionProps {
  data: any;
  theme: any;
  translation: any;
  fromResultScreen?: boolean;
}

enum HeadingLabels {
  HEADING_FIRST = "Heading First",
  HEADING_SECOND = "Heading Second",
  HEADING_THIRD = "Heading Third",
}

const LabelOnlySection = ({
  data,
  theme,
  translation,
  fromResultScreen = false,
}: LabelOnlySectionProps) => {
  const typography = useTypographyStore();
  const [showPreviewOverlay, setShowPreviewOverlay] = useState("");
  const headingFirst = data?.options.find(
    (item: any) => item.name === HeadingLabels.HEADING_FIRST
  );
  const headingSecond = data?.options.find(
    (item: any) => item.name === HeadingLabels.HEADING_SECOND
  );
  const headingThird = data?.options.find(
    (item: any) => item.name === HeadingLabels.HEADING_THIRD
  );

  const hyperlinkClicked = (hyperlink: string) => {
    setShowPreviewOverlay(hyperlink);
  };

  return (
    <ParentContainer theme={theme}>
      <FirstContainer theme={theme} fromResultScreen={fromResultScreen}>
        {headingFirst && (
          <VDBText
            type={typography[headingFirst?.typography_style]}
            color={theme["core-05"]}
          >
            {translation(headingFirst?.label)}
          </VDBText>
        )}

        {headingThird && (
          <RightContainer
            onPress={() => {
              hyperlinkClicked(headingThird?.hyperlink);
            }}
          >
            <VDBText
              type={typography[headingThird?.typography_style]}
              color={theme["link-static"]}
            >
              {translation(headingThird?.label)}
            </VDBText>
            <Spacer size={SpaceType.Basic} />
            <VDBIcon
              color={theme["core-04"]}
              size={16}
              variant={IconsVariant.VDBCustom}
              name={VDBIcons.QUESTION}
            />
          </RightContainer>
        )}
      </FirstContainer>

      {headingFirst && <Spacer size={SpaceType.ExtraSmall} />}
      {headingSecond && (
        <VDBText
          type={typography[headingSecond?.typography_style]}
          color={theme["core-05"]}
        >
          {translation(headingSecond?.label)}
        </VDBText>
      )}

      {showPreviewOverlay && showPreviewOverlay?.length > 0 && (
        <HyperLinkModal
          preview_link={showPreviewOverlay}
          isOpen={showPreviewOverlay !== ""}
          onClose={() => {
            setShowPreviewOverlay("");
          }}
          mTitle={"searchResult.parcel.mmtoct.text"}
        />
      )}
    </ParentContainer>
  );
};

const ParentContainer = styled.View<any>`
  flex-direction: column;
  background-color: ${({ theme }: { theme: DefaultTheme }) => theme["core-02"]};
  padding-top: 2px;
  padding-bottom: 2px;
  justify-content: center;
  height: 92px;
  padding-horizontal: 2px;
`;
const FirstContainer = styled.View<any>`
  flex-direction: ${({
    theme,
    fromResultScreen,
  }: {
    theme: DefaultTheme;
    fromResultScreen: boolean;
  }) => (theme.isMobile || fromResultScreen ? "column" : "row")};
  ${({
    theme,
    fromResultScreen,
  }: {
    theme: DefaultTheme;
    fromResultScreen: boolean;
  }) =>
    !theme.isMobile &&
    !fromResultScreen &&
    css`
      justify-content: space-between;
      align-items: center;
    `}
`;

const RightContainer = styled.TouchableOpacity`
  flex-direction: row;
`;

export default LabelOnlySection;
